module.exports = __webpack_public_path__ + "media/images/pc/page_common/banner/banner_fair-617e88e123d566290be12e8d371d57f7.jpg";